export const Themes = {
  light: {
    primary: '#2196f3',
    primary_flat: '#00000090',
    secondary: '#2196f320',
    secondary_flat: '#2196f350',
    background_body: '#f7f7f7',
    background_nav: '#fff',
    background_input: '#00000010',
    background: '#fff',
    color_text: '#00000095',
    border_color: '#00000020',
    light: '100%',
    hr_color: '#00000070',
  },
};
